import {Calendar, theme, CalendarProps, Tooltip, List} from 'antd'
import type {CalendarMode} from 'antd/es/calendar/generateCalendar'
import dayjs, {Dayjs} from 'dayjs'
import React from 'react'
import {ToDo} from '../../entities/todoList'
import {getToDoTypeInfo} from '../../entities/journalRecord'
import {useIntl} from 'react-intl'
import './calendarReminders.less'

const onPanelChange = (value: Dayjs, mode: CalendarMode) => {
  // console.log(value.format('YYYY-MM-DD'), mode)
}

function checkDate(todo: ToDo, currentDate: Dayjs) {
  if (!todo.targetStartDateUtc) {
    return null
  } else if (!todo.targetEndDateUtc && dayjs(todo.targetStartDateUtc).isSame(currentDate, 'day')) {
    return getToDoTypeInfo(todo.type).color
  } else if (
    currentDate >= dayjs(todo.targetStartDateUtc) &&
    currentDate <= dayjs(todo.targetEndDateUtc)
  ) {
    return getToDoTypeInfo(todo.type).color
  } else {
    return null
  }
}

export type CalendarRemindersProps = {
  todos: ToDo[]
  plantedPlantsNamesWithId?: {id: number; name: string}[]
}

export function CalendarReminders(props: CalendarRemindersProps) {
  const {token} = theme.useToken()
  const intl = useIntl()

  const wrapperStyle: React.CSSProperties = {
    border: `1px solid ${token.colorBorderSecondary}`,
    borderRadius: token.borderRadiusLG,
  }

  const cellRender: CalendarProps<Dayjs>['fullCellRender'] = (date, info) => {
    return (
      <Tooltip
        placement="bottom"
        title={getDateToDos(props.todos, date)}
        color={'rgba(245, 129, 83, 0.7)'}
      >
        <div style={{display: 'flex', flexDirection: 'column', position: 'relative'}}>
          <div>{date.get('date')}</div>
          {props.todos && (
            <div style={{flexDirection: 'row', position: 'absolute', width: '100%', top: '50%'}}>
              {props.todos.map((currentToDo, index) => {
                let todoColor = checkDate(currentToDo, date)
                if (!todoColor) {
                  return null
                }
                return (
                  <span style={{color: todoColor}} key={index}>
                    ●
                  </span>
                )
              })}
            </div>
          )}
        </div>
      </Tooltip>
    )
  }

  function getDateToDos(todos: ToDo[], currentDate: Dayjs) {
    const dateToDos = todos.filter((todo) => {
      if (!todo.targetStartDateUtc) {
        return false
      } else if (
        !todo.targetEndDateUtc &&
        dayjs(todo.targetStartDateUtc).isSame(currentDate, 'day')
      ) {
        return true
      } else if (
        currentDate >= dayjs(todo.targetStartDateUtc) &&
        currentDate <= dayjs(todo.targetEndDateUtc)
      ) {
        return true
      } else {
        return false
      }
    })

    if (dateToDos.length === 0) {
      return null
    }

    return (
      <ul>
        {dateToDos.map((item) => (
          <li key={item.id}>
            {item.type.type === 'custom' || !item.type.type
              ? getToDoTypeInfo(item.type).name
              : intl.formatMessage({id: `eventType-${getToDoTypeInfo(item.type).name}`})}
            {item.plants.length > 0 && (
              <span>
                {`: `}
                {item.plants.map((plant, index) => (index === 0 ? plant.name : `, ${plant.name}`))}
              </span>
            )}
          </li>
        ))}
      </ul>
    )
  }

  return (
    <div className="calendar-reminders" style={wrapperStyle}>
      <Calendar fullCellRender={cellRender} fullscreen={false} onPanelChange={onPanelChange} />
    </div>
  )
}
